import { ColumnTypesEnum } from '@/core';

type TagColorType = {
  [key: string]: string;
};

export const useTagColor = (columnType: string) => {
  const colorfulTags: TagColorType = {
    [ColumnTypesEnum.Other]: 'default',
    [ColumnTypesEnum.LoggedTime]: 'green',
    [ColumnTypesEnum.Epic]: 'orange',
    [ColumnTypesEnum.Employee]: 'blue',
  };

  return colorfulTags[columnType];
};
